export default "__VITE_PUBLIC_ASSET__5cfa643a__"